<template>
    <MainContent title="Editar evento">
        <template v-slot:header>
            <h3 class="card-title">Editar evento</h3>
        </template>
        <template v-slot:content>
            <div class="card-body" v-if="!loading">
                <div class="row">
                    <div class="col-12">
                        <FormComponent :evento="evento" v-on:terminado="editarEvento"></FormComponent>
                    </div>
                </div>
            </div>
            <div class="card-body" v-else>
                <div class="row">
                    <div class="col-12" style="height: 200px">
                        <LoaderComponent></LoaderComponent>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center" v-if="evento && evento.cerrar_butacas_abonados == 1">
                <CerrandoButacasAbonados @confirmar="confirmarCierreButacas()"></CerrandoButacasAbonados>
            </div>
        </template>
    </MainContent>
</template>

<script>
import FormComponent from '@/components/backend/eventos/FormEvento';
import MainContent from "@/components/backend/components/MainContent";
import CerrandoButacasAbonados from "./modals/CerrandoButacasAbonados";

export default { 
    props: ['evento_id'],
    data() {
        return {
            evento: null,
            loading: false
        }
    },
    created() {
        this.getEvento();
    },
    methods: {
        getEvento() {
            this.loading = true;

            const data = {
                evento_id: this.evento_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.detalle'), data).then(res => {
                this.evento = res.data.data;
            }).finally(() => this.loading = false);
        },
        editarEvento() {
            this.loading = true;

            this.evento.filters = {};

            this.evento.localidad = this.evento.location_id.nombre;
            this.evento.location_id = this.evento.location_id.id ?? 0;                
                
            if(this.evento.equipo_local_id) {
                this.evento.equipo_local_id = this.evento.equipo_local_id.id;
            }

            if(this.evento.equipo_visitante_id) {
                this.evento.equipo_visitante_id = this.evento.equipo_visitante_id.id;
            }

            if(this.evento.division_id) {
                this.evento.division_id = this.evento.division_id.id;
            }

            if(!this.evento.cerrar_butacas_abonados){
                this.evento.cerrar_butacas_abonados_no_confirmados = false; 
            }

            this.evento.evento_id = this.evento.id;

            if(this.evento.place_obj) {
                this.evento.place_id = this.evento.place_obj.id;
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.editar'), this.evento).then(res => {
                this.$toast.success('Evento editado correctamente');
                if (this.evento.cerrar_butacas_abonados) {
                    this.$modal.show('cerrando-butacas');
                } else {
                    this.$router.push({ name: 'back.events.index' });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        confirmarCierreButacas() {
            this.$modal.hide('cerrando-butacas');
            this.$router.push({ name: 'back.events.index' });
        }
    },
    components: {
        FormComponent, MainContent, CerrandoButacasAbonados
    }
}
</script>